import React, { useState, useEffect } from 'react';
import Config from '../../config';
import className from '../../utils/className';
import styles from './houseAd.css';

const HouseAd = () => {
  const [adContent, setAdContent] = useState({ header: '', description: '' });
  const [adTextSm, setAdTextSm] = useState(false);

  const setDescriptionFontSize = description => {
    // Remove any HTML tags
    const descriptionText = description.replaceAll(/<[^>]*>/g, '');

    if (descriptionText.length >= 30) {
      setAdTextSm(true);
    }
  };

  useEffect(() => {
    const houseAds = Config.houseAds;
    const header = houseAds.headers[Math.floor(Math.random() * houseAds.headers.length)];
    const description =
      houseAds.descriptions[Math.floor(Math.random() * houseAds.descriptions.length)];

    setDescriptionFontSize(description);
    setAdContent({ header, description });
  }, []);

  return (
    <div className={styles.wrapper}>
      <p className={styles.adHeader}>{adContent.header}</p>
      <p
        {...className(styles.adText, adTextSm && styles.adTextSm)}
        dangerouslySetInnerHTML={{ __html: adContent.description }}
      />
    </div>
  );
};

export default HouseAd;
